import LoadingIcons from 'react-loading-icons';
import { colors } from '../../../colors';

const FormSubmit = ({
  isLoading,
  onClick,
}: {
  isLoading?: boolean;
  onClick: () => void;
}) => {
  return (
    <div
      style={{
        color: colors.white,
        padding: 8,
        paddingLeft: 16,
        paddingRight: 16,
        backgroundColor: 'rgba(106, 106, 106, 0.6)',
        width: 'fit-content',
        height: 'fit-content',
        borderRadius: 8,
        marginLeft: 50,
        marginTop: 20,
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      {isLoading ? (
        <LoadingIcons.Grid width={15} height={15} />
      ) : (
        <p style={{ margin: 0, fontSize: 14, fontWeight: 'bold' }}>Submit</p>
      )}
    </div>
  );
};

export default FormSubmit;
